import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { joinWorkspace } from '../../../api/workspaces/join/joinWorkspace';

export function useJoinWorkspace() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      workspaceCode,
      workspaceId,
    }: {
      workspaceCode: string;
      workspaceId: string;
    }) => joinWorkspace({ workspaceCode, workspaceId }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: workspaceKeys.all });
    },
  });
}
